import React, { useContext, useEffect, useState } from "react";
import { ACCOUNT_TYPE_NORMAL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import HeartIcon from "@components/Icons/HeartIcon/index.js";
import Button from "@components/Ui/Button";
import { fetchWatchlistStatus, toggleWatchlist } from "@utils/watchlistService";
import "./style.scss";

const AddToWatchListButton = ({ movieId, initialInWatchlist, onToggle, forceLightColor = false }) => {
    const { user } = useContext(AuthContext);
    const [isInWatchlist, setIsInWatchlist] = useState(initialInWatchlist || false);
    const isNormal = user?.account_type_id === ACCOUNT_TYPE_NORMAL;

    useEffect(() => {
        if (initialInWatchlist !== undefined) {
            setIsInWatchlist(initialInWatchlist);
            return;
        }

        if (isNormal && movieId) {
            fetchWatchlistStatus([movieId], user, (status) => {
                setIsInWatchlist(status[movieId] || false);
            });
        }
    }, [movieId, isNormal, user]);

    if (!isNormal) {
        return null;
    }

    const handleToggle = () => {
        const previousState = isInWatchlist;
        const newState = !isInWatchlist;

        setIsInWatchlist(newState);

        toggleWatchlist(
            movieId,
            user,
            (inWatchlist, action) => {
                setIsInWatchlist(inWatchlist);
                if (onToggle) {
                    onToggle(inWatchlist, action);
                }
            },
            () => {
                setIsInWatchlist(previousState);
            }
        );
    };

    return (
        <Button
            additionalClasses={`add-to-watchlist__button ${isInWatchlist ? "add-to-watchlist__button--active" : ""} ${forceLightColor ? "add-to-watchlist__button--light" : ""}`}
            onClick={handleToggle}
        >
            <HeartIcon
                className={`add-to-watchlist__svg ${isInWatchlist ? "add-to-watchlist__svg--filled" : ""}`}
                filled={isInWatchlist}
            />
            <span className="add-to-watchlist__button-text">Watchlist</span>
        </Button>
    );
};

export default AddToWatchListButton;
